/**
 * KeywordSearchContainer - Handles keyword search form and loading states
 * Extracted from AppKeywordResearchPage for better separation of concerns
 */

import React from 'react';
import { Button } from '@/components/ui/button';
import { ExternalLink } from 'lucide-react';
import KeywordSearchForm from '../KeywordSearchForm';

interface KeywordSearchContainerProps {
  onSearch: (keyword: string, languageName: string, countryName: string) => Promise<void>;
  isLoading: boolean;
  loadingMessage: string;
  searchParams?: {
    query: string;
    langName: string;
    countryName: string;
  } | null;
  onNewResearch?: () => void;
  hasResults?: boolean;
}

const KeywordSearchContainer: React.FC<KeywordSearchContainerProps> = ({
  onSearch,
  isLoading,
  loadingMessage,
  searchParams,
  onNewResearch,
  hasResults
}) => {
  return (
    <div className="px-6 py-6 border-b border-border/30">
      <div className="space-y-4">
        <KeywordSearchForm 
          onSearch={onSearch} 
          isSearching={isLoading} 
          loadingMessage={loadingMessage}
          initialKeyword={searchParams?.query || ''}
          initialLanguage={searchParams?.langName || 'English'}
          initialCountry={searchParams?.countryName || 'United States'}
        />
        
        {/* New Research Button - only show when there are results */}
        {hasResults && onNewResearch && !isLoading && (
          <div className="flex justify-center">
            <Button
              onClick={onNewResearch}
              variant="outline"
              className="flex items-center gap-2 text-muted-foreground hover:text-foreground"
            >
              <ExternalLink className="h-4 w-4" />
              New Research
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};

export default KeywordSearchContainer;